<mat-dialog-content class="customer-dialog">
  <!-- Search Section -->
  <!-- <div class="search-container">
    <mat-form-field >
      <mat-label></mat-label>
      <input matInput [(ngModel)]="" (keyup)="">
    </mat-form-field>

    <mat-form-field  >
      <mat-label></mat-label>
      <input matInput [(ngModel)]="" (keyup)="">
    </mat-form-field>

  </div> -->



  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">Code </th>
        <th style="width: 50%;"> Name</th>
        <th style="width: 50%;">Arabic  Name</th>
        <th style="width: 20%;">Choose</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let item of CompamyList; let i = index">
        <td>{{item.insid}}</td>
        <td>{{item.insenglishname}}</td>
        <td>{{item.insarabicname}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectItem(item)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </mat-dialog-content>


